import React from "react"

const LanguageContext = React.createContext({
    language: null,
    changeLanguage: () => {},
})
export default LanguageContext
